var exports = {
  "n": "xfd349460--4b50f3--link",
  "U": "xfd349460--4b50f3--arrow",
};

module.exports = exports;
